// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.site-content[data-v-4ecaa88a] {\n  display: flex;\n  justify-content: center;\n}\n.site-content__inner[data-v-4ecaa88a] {\n  width: 600px;\n}\n", ""]);
// Exports
module.exports = exports;
